import React from 'react';
import './uploadDocumentos.scss';
import '../../components/breadcrumbs/breadcrumbs.scss';
import FileUpload from '../../components/fileUpload';
import Table from '../../components/table';
import { tipoDocImagem } from '../../helper/constants';

//Componentes
import Label from '../../components/label';
import Loading from "../../components/loading";

class UploadDocumentos extends React.Component {

  state = {
    files: [],
    filesError: [],
  }

  componentDidMount() {
    this.formFields = [];
    this.input = [];

    const { match, listDocumentosSolicitadosAction, history } = this.props;
    const params = match.params;

    if (params && params.id) {
      listDocumentosSolicitadosAction(params.id, history);
    } else {
      history.push("/");
    }
  }

  handleChangeFile = (element) => {

    let newFilesError = this.state.filesError.filter(x => x.IdTipoDocumento !== element.documentType || x.Verso !== (element.imageType === tipoDocImagem.Verso))
    this.setState({...this.state, }); 

    if (!element.base64 && element.deleteAll) {
      const newStateFiles = this.state.files.filter(x => x.IdTipoDocumento !== element.documentType);
      this.setState({...this.state, files: newStateFiles, filesError: newFilesError})
    } else if (element.errorNotification && element.errorNotification !== "") {
      const fileError = {
        IdTipoDocumento: element.documentType,
        Verso: element.imageType === tipoDocImagem.Verso,
        Msg: element.errorNotification
      }
      newFilesError = newFilesError.concat(fileError);
      this.setState({...this.state, filesError: newFilesError});
    } else if (element.base64 && 
      this.state.files.find(x => x.Base64 === element.base64 && x.IdTipoDocumento === element.typeDocument && x.Verso === (element.imageType === tipoDocImagem.Verso)) === undefined) {
      const {documentosSolicitados} = this.props.uploadDocumentos;

      const file = {
        IdSolicitacao: documentosSolicitados[0].IdSolicitacao,
        Base64: element.base64,
        IdTipoDocumento: element.documentType,
        Nome: element.text,
        TipoArquivo: element.fileType.toLowerCase() === "jpeg" ? "jpg" : element.fileType.toLowerCase(),
        Arquivo: element.value,
        DuasFaces: element.imageType === tipoDocImagem.Frente || element.imageType === tipoDocImagem.Verso, // tipo frente ou verso
        Verso: element.imageType === tipoDocImagem.Verso,
        IdPessoa: documentosSolicitados[0].IdCliente,
        text: element.text
      }
  
      const newStateFile = this.state.files.concat(file);
      this.setState({ ...this.state, files:newStateFile, filesError: newFilesError })
    }
  }

  findFile = (item, verso = false) => {
    return this.state.files.find(x => x.IdTipoDocumento === item.IdTipoDocumento && 
      x.Verso === verso)
  }

  filterFiles = (item, verso = false) => {
    return this.state.files.filter(x => x.IdTipoDocumento === item.IdTipoDocumento && 
      x.Verso === verso)
  }
 
  deleteFiles = (typeDocument) => {
   
  }

  deleteFile = (file) => {
    const newStateFiles = this.state.files.filter(x => x.Base64 !== file.Base64 || x.IdTipoDocumento !== file.IdTipoDocumento || x.Verso !== file.Verso);
    this.setState({...this.state, files: newStateFiles})
  }

  enviar = () => {
    const {tiposDocumentoSolicitados} = this.props.uploadDocumentos;
    const {enviarArquivos, history} = this.props;

    let filesError = [];
    let fileError = {};
    for (var x = 0; x < tiposDocumentoSolicitados.length; x++) {
      if (this.findFile(tiposDocumentoSolicitados[x]) === undefined) {
        fileError = {
          IdTipoDocumento: tiposDocumentoSolicitados[x].IdTipoDocumento,
          Verso: false,
          Msg: `${tiposDocumentoSolicitados[x].DuasFaces ? "Frente do " : ""}${tiposDocumentoSolicitados[x].Nome} obrigatório!`
        }
        filesError = filesError.concat(fileError);
      }

      if (tiposDocumentoSolicitados[x].DuasFaces) {
        if (this.findFile(tiposDocumentoSolicitados[x], true) === undefined) {
          fileError = {
            IdTipoDocumento: tiposDocumentoSolicitados[x].IdTipoDocumento,
            Verso: true,
            Msg: `Verso do ${tiposDocumentoSolicitados[x].Nome} obrigatório!`
          }
          filesError = filesError.concat(fileError);
        }
      }
    }   

    if (filesError.length > 0) {
      this.setState({...this.state, filesError: filesError})
    } else {
      enviarArquivos(this.state.files, history);
    }      
  }

  getMsgFileError = (item, verso) => {
    const fileErroFound = this.state.filesError.find(x => x.IdTipoDocumento === item.IdTipoDocumento && x.Verso === verso);
    if (fileErroFound) {
      return fileErroFound.Msg
    } else {
      return "";
    }
  }

  render() {

    let {
      loadingPage,
      documentosSolicitados,
      tiposDocumentoSolicitados
    } = this.props.uploadDocumentos;

    if (loadingPage) {
      return <div className="loadingUploadDoc"><Loading /></div>;
    }

    if (documentosSolicitados === null || documentosSolicitados === undefined
      || tiposDocumentoSolicitados === null || tiposDocumentoSolicitados === undefined)
      return <div></div>;

    this.input = [tiposDocumentoSolicitados.length];
    this.inputVerso = [tiposDocumentoSolicitados.length];

    return (
      <section className="container">
        <div className="col">
          <div className="breadcrumbs">
            <ul className="breadcrumbs-list">
              <li className={`breadcrumbs-list-item breadcrumb-active`}></li>

                <li className={`breadcrumbs-list-item-whiteBorder`}></li>
            </ul>
            <h1 className="title">Envio de Documentos</h1>
            <span className="line"></span>
          </div>
        </div>
        <div className="col">
          <span>Prezado cliente <strong>{documentosSolicitados[0].NomeCliente}</strong>, solicitamos o envio dos documentos abaixo:</span>
        </div>
        <div className="col">
          <Label type="title" label="Documentos Solicitados" />
        </div>

        {tiposDocumentoSolicitados.map((item, index) => {
          // return !item.DuasFaces ? (
          return (
            <div key={index}>
              <FileUpload
                name="groupUpload"
                // id={`inputUpload_${item.IdTipoDocumento}`}
                id={`${item.Nome}`}
                onChange={this.handleChangeFile}
                textFile={`${item.Descricao} ${item.DuasFaces ? "(Frente)*" : "*"}`}
                // subText="RG, CNH ou documento de orgão de classe dentro do prazo de validade."
                listTypeArquivo={["png", "jpg", "pdf", "jpeg"]}
                documentType={item.IdTipoDocumento}
                imageType={item.DuasFaces ? tipoDocImagem.Frente : tipoDocImagem.Comprovante}
                base64={this.filterFiles(item).length > 0 ? this.filterFiles(item)[0].Base64 : null}
                documents={this.filterFiles(item)}
                limit={item.LimiteAnexoSolicitacao}
                onlyOneArchive={item.LimiteAnexoSolicitacao === 1}
                errorMessage={this.getMsgFileError(item, false)}
                disable={this.filterFiles(item).length >= item.LimiteAnexoSolicitacao}
              />

              <Table
                list={this.state.files.filter(x => x.IdTipoDocumento === item.IdTipoDocumento && !x.Verso)}
                onClick={this.deleteFile}
              />

              {item.DuasFaces && (
                <div>
                  <FileUpload
                    name="groupUpload"
                    id={`${item.Nome}_Verso`}
                    onChange={this.handleChangeFile}
                    textFile={`${item.Descricao} (Verso)*`}
                    // subText="RG, CNH ou documento de orgão de classe dentro do prazo de validade."
                    listTypeArquivo={["png", "jpeg", "pdf"]}
                    documentType={item.IdTipoDocumento}
                    imageType={tipoDocImagem.Verso}
                    base64={this.filterFiles(item, true).length > 0 ? this.filterFiles(item, true)[0].Base64 : null}
                    documents={this.filterFiles(item, true)}
                    limit={item.LimiteAnexoSolicitacao}
                    onlyOneArchive={item.LimiteAnexoSolicitacao === 1}
                    errorMessage={this.getMsgFileError(item, true)}
                    disable={this.filterFiles(item, true).length >= item.LimiteAnexoSolicitacao}
                  />

                  <Table
                    list={this.state.files.filter(x => x.IdTipoDocumento === item.IdTipoDocumento && x.Verso)}
                    onClick={this.deleteFile}
                  />

                </div>
              )}
              
            </div>         
          )
        })}

        <div className="groupEnviar">
          <button 
            className="buttonEnviar"
            onClick={() => this.enviar()}
          >
            Enviar
          </button>
        </div>
      </section>
    );
  }
}

export default UploadDocumentos;

